var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMyProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "avatar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 34,
    height: 34,
    transform: "translate(810 137)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8",
    "data-name": "Mask Group 8",
    transform: "translate(-810 -137)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_user_",
    "data-name": "FontAwsome (user)",
    d: "M15.925,15.437c-1.457,0-2.158.812-4.55.812s-3.087-.812-4.55-.812A6.827,6.827,0,0,0,0,22.262v1.3A2.438,2.438,0,0,0,2.437,26H20.312a2.438,2.438,0,0,0,2.437-2.437v-1.3A6.827,6.827,0,0,0,15.925,15.437Zm4.387,8.125H2.437v-1.3a4.4,4.4,0,0,1,4.387-4.387c.741,0,1.945.812,4.55.812,2.625,0,3.8-.812,4.55-.812a4.4,4.4,0,0,1,4.387,4.387Zm-8.937-8.937A7.312,7.312,0,1,0,4.062,7.312,7.314,7.314,0,0,0,11.375,14.625Zm0-12.187A4.875,4.875,0,1,1,6.5,7.312,4.883,4.883,0,0,1,11.375,2.437Z",
    transform: "translate(816 141)",
    fill: "#b1cb79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyProfile);
export default __webpack_public_path__ + "static/media/icon_my_profile.9840f9d9d0e8bacb4f08078a4f308500.svg";
export { ForwardRef as ReactComponent };